import { render, staticRenderFns } from "./FertilizerContentsDisplay.vue?vue&type=template&id=cf542d2e&scoped=true&lang=html&"
import script from "./FertilizerContentsDisplay.vue?vue&type=script&lang=js&"
export * from "./FertilizerContentsDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf542d2e",
  null
  
)

export default component.exports